import { coreClient } from '@/api/coreclient'
import { ManualFixes } from 'common'

export default {
  // Proposed Edits
  async listProposedEdits() {
    const client = await coreClient()
    return client.dataPipelineManualFixes.listProposedEdits().then((data) => {
      return data.data
    })
  },
  async updateProposedEdit(body: {
    where: { id: string }
    updates: { data?: string; where_clause?: string }
  }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.updateProposedEdit(body)
  },
  async approveProposedEdit(id: string) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.approveProposedEdit(id)
  },
  async deleteProposedEdit(id: string) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.deleteProposedEdit(id)
  },

  // Do Not Merge
  async listDoNotMerge() {
    const client = await coreClient()
    return client.dataPipelineManualFixes.listDoNotMerge().then((data) => {
      return data.data
    })
  },
  async insertDoNotMerge(body: { id: string; address1: string; address2: string }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.insertDoNotMerge(body)
  },
  async updateDoNotMerge(body: {
    where: { id?: string; address1?: string; address2?: string }
    updates: { id?: string; address1?: string; address2?: string }
  }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.updateDoNotMerge(body)
  },
  async deleteDoNotMerge(id: string) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.deleteDoNotMerge(id)
  },

  // Excluded URLs
  async listExcludedUrls() {
    const client = await coreClient()
    return client.dataPipelineManualFixes.listExcludedUrls().then((data) => {
      return data.data
    })
  },
  async insertExcludedUrl(body: { url: string }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.insertExcludedUrl(body)
  },
  async updateExcludedUrl(body: { where: { url?: string }; updates: { url?: string } }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.updateExcludedUrl(body)
  },
  async deleteExcludedUrl(url: string) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.deleteExcludedUrl(url)
  },

  // Prioritize Listing
  async listPrioritizeListing() {
    const client = await coreClient()
    return client.dataPipelineManualFixes.listPrioritizeListing().then((data) => {
      return data.data
    })
  },
  async insertPrioritizeListing(body: { building_id: string; listing_source: string }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.insertPrioritizeListing(body)
  },
  async updatePrioritizeListing(body: {
    where: { building_id?: string; listing_source?: string }
    updates: { building_id?: string; listing_source?: string }
  }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.updatePrioritizeListing(body)
  },
  async deletePrioritizeListing(building_id: string, listing_source: string) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.deletePrioritizeListing(building_id, listing_source)
  },

  // Address Rename
  async listAddressRename() {
    const client = await coreClient()
    return client.dataPipelineManualFixes.listAddressRename().then((data) => {
      return data.data
    })
  },
  async insertAddressRename(body: {
    id: string
    building_name_pattern?: string
    address_pattern: string
    renamed_address: string
  }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.insertAddressRename(body)
  },
  async updateAddressRename(body: {
    where: { id?: string; address_pattern?: string }
    updates: {
      id?: string
      building_name_pattern?: string
      address_pattern?: string
      renamed_address?: string
    }
  }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.updateAddressRename(body)
  },
  async deleteAddressRename(id: string) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.deleteAddressRename(id)
  },

  // Allowed Website Domains
  async listAllowedWebsiteDomains() {
    const client = await coreClient()
    return client.dataPipelineManualFixes.listAllowedWebsiteDomains().then((data) => {
      return data.data
    })
  },
  async insertAllowedWebsiteDomain(body: { domain_pattern: string }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.insertAllowedWebsiteDomain(body)
  },
  async updateAllowedWebsiteDomain(body: {
    where: { id?: number }
    updates: { domain_pattern?: string }
  }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.updateAllowedWebsiteDomain(body)
  },
  async deleteAllowedWebsiteDomain(id: number) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.deleteAllowedWebsiteDomain(id)
  },

  // Building Overrides
  async listBuildingOverrides() {
    const client = await coreClient()
    return client.dataPipelineManualFixes.listBuildingOverrides().then((data) => {
      return data.data
    })
  },
  async insertBuildingOverride(body: Omit<ManualFixes.BuildingOverride, 'created_on' | 'created_by'>) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.insertBuildingOverride(body)
  },
  async updateBuildingOverride(body: {
    where: { id: string }
    updates: Partial<ManualFixes.BuildingOverride>
  }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.updateBuildingOverride(body)
  },
  async deleteBuildingOverride(id: string) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.deleteBuildingOverride(id)
  },

  // Do Merge Addresses
  async listDoMergeAddresses() {
    const client = await coreClient()
    return client.dataPipelineManualFixes.listDoMergeAddresses().then((data) => {
      return data.data
    })
  },
  async insertDoMergeAddress(body: { merge_group_id: string; address: string }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.insertDoMergeAddress(body)
  },
  async updateDoMergeAddress(body: {
    where: { merge_group_id?: string; address?: string }
    updates: { merge_group_id?: string; address?: string }
  }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.updateDoMergeAddress(body)
  },
  async deleteDoMergeAddress(merge_group_id: string, address: string) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.deleteDoMergeAddress(merge_group_id, address)
  },

  // Sightmap URLs
  async listSightmapUrls() {
    const client = await coreClient()
    return client.dataPipelineManualFixes.listSightmapUrls().then((data) => {
      return data.data
    })
  },
  async insertSightmapUrl(body: Omit<ManualFixes.SightmapUrl, 'created_on' | 'created_by'>) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.insertSightmapUrl(body)
  },
  async updateSightmapUrl(body: {
    where: { widget_hash_id: string }
    updates: Partial<ManualFixes.SightmapUrl>
  }) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.updateSightmapUrl(body)
  },
  async deleteSightmapUrl(widget_hash_id: string) {
    const client = await coreClient()
    return client.dataPipelineManualFixes.deleteSightmapUrl(widget_hash_id)
  }
}
